import { render, staticRenderFns } from "./m_vlogskill.vue?vue&type=template&id=1045a1e5&scoped=true&"
import script from "./m_vlogskill.vue?vue&type=script&lang=js&"
export * from "./m_vlogskill.vue?vue&type=script&lang=js&"
import style0 from "./m_vlogskill.vue?vue&type=style&index=0&id=1045a1e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045a1e5",
  null
  
)

export default component.exports